import './vendor-scripts';
import './tip.js';

// import polyfills
import './polyfills';

// import theme scripts
import './main';

// import forms
import './forms';

// import pages
import './pages/home';
import './pages/brokers';

window.$ = jQuery;

// finished
(function () {
    console.info('Initialized "joelle".');

    $('body').addClass('loaded');

    if ($('body').hasClass('disable-anim') === false && typeof WOW !== 'undefined')
        new WOW({mobile: false}).init();

    $('[data-toggle="tooltip"]').tooltip();

})();

window.showLoader = true;
window.addEventListener('beforeunload', function (event) {
    if (window.showLoader) {
        $('body').removeClass('loaded');
    }
});

